import React from 'react';
import { AspectRatio } from '@ff-os/shared-react/components/aspect-ratio/AspectRatio';
import { range } from 'lodash';
import { PhotoPrintLoader } from '../../photo-print/PhotoPrintLoader';
import { PhotoPrintSpinner } from '../../photo-print/PhotoPrintSpinner';
import { PhotoPrintPreviewMobile } from '../photo-print/PhotoPrintPreviewMobile';
import styles from './TruncatedPhotoPrintsList.module.scss';

export const TruncatedPhotoPrintsList = ({ photoIds, amountInQueue, maxPreviewCount }: Props) => {

    const totalPhotoCount = amountInQueue + photoIds.length;
    const remainingSlotCount = Math.max(maxPreviewCount - photoIds.length, 0);
    const spinnerCount = Math.min(remainingSlotCount, amountInQueue);

    return (
        <ul className={styles.container}>

            {photoIds.slice(0, maxPreviewCount).map(id => (
                <li key={id}>
                    <PhotoPrintLoader id={id}>
                        <PhotoPrintPreviewMobile id={id} />
                    </PhotoPrintLoader>
                </li>
            ))}

            {range(0, spinnerCount).map(i => (
                <li key={i}>
                    <PhotoPrintSpinner />
                </li>
            ))}

            {totalPhotoCount > maxPreviewCount && (
                <li>
                    <AspectRatio>
                        <div className={styles.restOfPhotos}>
                            +{totalPhotoCount - maxPreviewCount}
                        </div>
                    </AspectRatio>
                </li>
            )}

        </ul>
    );
};

type Props = {
    photoIds: string[];
    amountInQueue: number;
    maxPreviewCount: number;
};